<template>
    <cart-discount class="cart-discount" style="text-align: initial;" :key="keyCartDiscount">
        <LoadingApp
            :isLoading.sync="isLoading"
            :is_full_page="true"
        />
        <h4 :style="!isPageCheckout ? 'padding: 20px 0px 10px 0px;' : null">Cupom de desconto</h4>
        <form
            @submit.prevent="submit"
            method="post"
        >
            <div class="input-group">
                <input
                    type="text"
                    v-model="form.code"
                    class="form-control form-control-sm"
                    placeholder="Insira o código do cupom"
                    :style="'height: 3.8rem; margin-right: 13px; font-family:'+$root.$children[0].theme.font_family"
                />
                <div class="input-group-append">
                    <c-button
                        :backgroundColor="$root.$children[0].theme.products.button.background_color"
                        :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                        :color="$root.$children[0].theme.products.button.color"
                        :colorHover="$root.$children[0].theme.products.button.color_hover"
                        :borderColor="$root.$children[0].theme.products.button.border_color"
                        :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                        :borderRadius="$root.$children[0].theme.products.button.border_radius"
                        :textTransform="$root.$children[0].theme.products.button.text_transform"
                        type="submit"
                        margin="unset"
                        height="3.8rem"
                    >
                        Aplicar
                    </c-button>
                </div>
            </div>
        </form>
    </cart-discount>
</template>

<script>
import LoadingApp from '../LoadingApp'
import {mapActions, mapState} from 'vuex'
import {CButton} from '../../components/Styles/Button/styled'
import { CCartDiscount } from '../Styles/Template/styled'

export default {
    name: 'CartDiscount',
    props: {
        isPageCheckout: {default:false}
    },
    components: {
        LoadingApp,
        'c-button': CButton,
        'cart-discount': CCartDiscount
    },
    data() {
        return {
            isLoading: false,
            form: {
                code: ''
            },
            keyCartDiscount:0
        }
    },
    mounted() {
        const savedCoupon = localStorage.getItem('@cart_coupom_code')
        if (savedCoupon) {
            this.form.code = savedCoupon
            this.applySavedCoupon()
        }
        this.setUserCoupon()
    },
    methods: {
        ...mapActions("cart", [
            "ActionApplyDiscount",
            "ActionGetItemsCart",
            "ActionSetItemsCart"
        ]),
        ...mapActions("toast", [
            "setShowToast",
            "setMessageToast",
            "setTimerToast",
            "setIconToast",
            "setThemeToast"
        ]),
        setUserCoupon() {
            if(!this.client || !this.client.coupon_code || this.form.code || this.isPageCheckout || this.itemsCart.discountAmount > 0) {
                return
            }
            this.$swal({
                title: `<span style="color: ${this.$root.$children[0].theme?.text_site_color ?? '#4a505e'}; display: inline-block; padding-bottom: 20px; padding: 8px; font-size: 2rem; font-weight: 600;">Você possui um cupom de desconto. Deseja usá-lo?</span>`,
                text: "",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#777',
                cancelButtonText: `<span style="font-size: 1.6rem; font-weight: 500">Não</span>`,
                confirmButtonText: `<span style="font-size: 1.6rem; font-weight: 500">Sim</span>`,
                background: this.$root.$children[0].theme?.background_color_site ?? '#fff',
                reverseButtons: true
            })
            .then(async (resp) => {
                if(resp.value) {
                    this.form.code = this.client.coupon_code
                    this.submit()
                }
            })
            .catch((error) => {
                if(error.msg) {
                    return alert(error.msg)
                }
                return alert(error)
            })
        },
        async getItemsCart() {
            await this.ActionGetItemsCart()
            .then((resp) => {
                let { data } = resp
                this.ActionSetItemsCart(data)
            })
            .catch((error) => {
                if(error.msg) {
                    console.log('ERROR GET ITEMS CART: '+error.msg)
                    return
                }
                console.log('ERROR GET ITEMS CART: '+error)
            })
        },
        alertToast(msg = null, icon = "exclamation", theme = 'warning', timer = 7) {
            this.setThemeToast(theme)
            this.setMessageToast(msg)
            this.setIconToast(icon)
            this.setTimerToast(timer)
            this.setShowToast(true)
            setTimeout(() => {
                this.setShowToast(false)
            }, (timer * 1000));
        },
        async submit() {
            this.isLoading = true
            await this.ActionApplyDiscount(this.form)
            .then(async (response) => {
                this.isLoading = false
                localStorage.setItem('@cart_coupom_code', this.form.code)
                
                await this.getItemsCart()
                this.alertToast('Desconto aplicado com sucesso!', 'check', 'success', 5)
                // this.$swal({
                //     toast: true,
                //     position: 'bottom-end',
                //     showConfirmButton: false,
                //     timer: 3000,
                //     timerProgressBar: true,
                //     background: this.$root.$children[0].theme?.background_color_site ?? '#fff',
                //     icon: 'success',
                //     title: `<span style="color: ${this.$root.$children[0].theme?.text_site_color ?? '#4a505e'}; padding: 8px; font-size: 1.4rem; font-weight: 600;">
                //                 Desconto aplicado com sucesso!
                //             </span>`
                // })
            })
            .catch((error) => {
                this.isLoading = false
                localStorage.removeItem('@cart_coupom_code')
                this.getItemsCart()
                this.alertToast(error?.msg ?? error)
                // this.$swal({
                //     title: `<span style="color: ${this.$root.$children[0].theme?.text_site_color ?? '#4a505e'}; display: inline-block; padding-bottom: 20px; padding: 8px; font-size: 2rem; font-weight: 600;">
                //             ${error?.msg ?? error}
                //         </span>`,
                //     icon: 'warning',
                //     confirmButtonColor: '#3085d6',
                //     confirmButtonText: `<span style="font-size: 1.6rem; font-weight: 500">OK</span>`,
                //     background: this.$root.$children[0].theme?.background_color_site ?? '#fff',
                // })
            })

        },
        applySavedCoupon() {
            if(!this.form.code || this.itemsCart.discountAmount > 0) {
                return
            }
            this.submit()
        }
    },
    computed: {
        ...mapState("clients", [
            "client"
        ]),
        ...mapState("cart", [
            "itemsCart"
        ])
    }
}
</script>
